import React from 'react'
import { DynamicRoute } from 'lib/shared'
import { CmsPage } from 'lib/shared/scenes/CmsPage'
import { ProductScene } from 'scenes/Product'
import { CategoryScene } from 'app/livbrite/scenes/Category'
import { NoMatch } from 'app/livbrite/scenes/NoMatch'

export const EntityResolver = () => {
  return (
    <DynamicRoute
      components={{
        Category: CategoryScene,
        CmsPage,
        Product: ProductScene,
        NoMatch
      }}
    />
  )
}
